// eslint-disable-next-line import/no-namespace
import * as Primer from '@primer/octicons-react'

import {documentToReactComponents} from '@contentful/rich-text-react-renderer'
import {BLOCKS} from '@contentful/rich-text-types'
import {Card} from '@primer/react-brand'

import type {PrimerComponentCard} from '../../../schemas/contentful/contentTypes/primerComponentCard'

const toTitleCase = (str: string) => {
  return `${str
    .toLowerCase()
    .split('-')
    .map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1)
    })
    .join('')}Icon`
}

export const getPrimerIcon = (name: string = ''): Primer.Icon | undefined => {
  const titleCaseName = toTitleCase(name)
  const iconMap: {[key: string]: Primer.Icon} = Primer
  return iconMap[titleCaseName] ? iconMap[titleCaseName] : undefined
}

export type ContentfulCardProps = {
  component: PrimerComponentCard

  /**
   * The props below do not have a corresponding field in Contentful:
   */
  className?: string
}

export const ContentfulCard = ({component, className}: ContentfulCardProps) => {
  const Octicon = getPrimerIcon(component.fields.icon)
  const iconColor = component.fields.iconColor || 'default'
  const hasBackground = component.fields.iconBackground

  return (
    <Card href={component.fields.href} ctaText={component.fields.ctaText} className={className}>
      {Octicon && (
        <Card.Icon
          data-testid={`${component.fields.icon}-${component.fields.href}`}
          icon={<Octicon />}
          color={iconColor}
          hasBackground={hasBackground}
        />
      )}

      <Card.Heading>{component.fields.heading}</Card.Heading>

      {component.fields.label && <Card.Label>{component.fields.label}</Card.Label>}

      {component.fields.description &&
        documentToReactComponents(component.fields.description, {
          renderNode: {
            [BLOCKS.PARAGRAPH]: (_, children: React.ReactNode) => <Card.Description>{children}</Card.Description>,
          },
        })}
    </Card>
  )
}

try{ ContentfulCard.displayName ||= 'ContentfulCard' } catch {}
try{ Octicon.displayName ||= 'Octicon' } catch {}